var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1109,
    viewBox: "0 0 1440 1109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M718.6 263.568C371.385 244.506 367.697 609.484 409.255 794.356C581.525 1268.79 882.715 984.902 868.475 676.322C854.234 367.741 1295.6 758.269 1462.83 411.795C1656.74 10.0437 1152.62 287.395 718.6 263.568Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95875,
    d: "M722.917 279.503C376.579 248.335 360.156 612.963 395.236 799.172C550.844 1279.33 861.758 1006.13 858.295 697.236C854.833 388.347 1282.3 794.04 1461.52 453.613C1669.33 58.8739 1155.84 318.463 722.917 279.503Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9175,
    d: "M726.675 295.579C381.635 252.343 352.497 616.175 381.058 803.495C519.813 1288.79 840.072 1026.6 847.392 717.782C854.711 408.96 1267.76 829.324 1458.75 495.359C1680.21 108.113 1157.97 349.624 726.675 295.579Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87625,
    d: "M729.869 311.775C386.549 256.524 344.73 619.118 366.736 807.321C488.471 1297.16 817.685 1046.31 835.778 737.935C853.871 429.556 1252 864.08 1454.53 536.984C1689.37 157.703 1159.02 380.84 729.869 311.775Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.835,
    d: "M732.496 328.074C391.313 260.875 336.866 621.788 352.29 810.645C456.855 1304.43 794.624 1065.23 823.468 757.67C852.312 450.111 1235.03 898.264 1448.85 578.435C1696.79 207.581 1158.97 412.073 732.496 328.074Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79375,
    d: "M734.553 344.454C395.923 265.389 328.913 624.182 337.737 813.462C425.006 1310.6 770.916 1083.33 810.476 776.963C850.037 470.598 1216.88 931.835 1441.74 619.664C1702.46 257.688 1157.84 443.286 734.553 344.454Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7525,
    d: "M736.037 360.896C400.372 270.061 320.882 626.297 323.095 815.77C392.96 1315.65 746.592 1100.59 796.82 795.792C847.048 490.994 1197.57 964.752 1433.18 660.618C1706.39 307.963 1155.62 474.441 736.037 360.896Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71125,
    d: "M736.946 377.38C404.656 274.886 312.781 628.131 308.38 817.565C360.758 1319.58 721.679 1116.99 782.514 814.132C843.349 511.272 1177.12 996.975 1423.21 701.25C1708.55 358.344 1152.31 505.499 736.946 377.38Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M737.279 393.886C408.768 279.857 304.622 629.68 293.612 818.846C328.438 1322.38 696.21 1132.51 767.577 831.962C838.944 531.41 1155.57 1028.47 1411.82 741.508C1708.96 408.769 1147.92 536.422 737.279 393.886Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62875,
    d: "M737.036 410.393C412.705 284.969 296.413 630.944 278.809 819.61C296.04 1324.05 670.214 1147.14 752.027 849.259C833.84 551.381 1132.92 1059.18 1399.03 781.345C1707.6 459.179 1142.45 567.174 737.036 410.393Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5875,
    d: "M736.217 426.882C416.461 290.215 288.166 631.921 263.987 819.858C263.603 1324.6 643.724 1160.85 735.883 866.004C828.041 571.162 1109.22 1089.09 1384.87 820.711C1704.49 509.51 1135.91 597.715 736.217 426.882Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54625,
    d: "M734.822 443.331C420.03 295.588 279.888 632.609 249.165 819.587C231.166 1324 616.77 1173.62 719.163 882.174C821.555 590.729 1084.49 1118.16 1369.33 859.558C1699.62 559.701 1128.31 628.01 734.822 443.331Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.505,
    d: "M732.855 459.722C423.411 301.083 271.592 633.008 234.363 818.8C198.771 1322.28 589.388 1185.45 701.89 897.752C814.391 610.057 1058.75 1146.34 1352.45 897.84C1693.01 609.693 1119.66 658.021 732.855 459.722Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46375,
    d: "M730.318 476.036C426.599 306.694 263.288 633.118 219.598 817.497C166.456 1319.43 561.611 1196.31 684.085 912.717C806.558 629.124 1032.06 1173.61 1334.25 935.51C1684.65 659.423 1109.97 687.713 730.318 476.036Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4225,
    d: "M727.211 492.249C429.587 312.411 254.984 632.937 204.885 815.679C134.259 1315.45 533.47 1206.2 665.766 927.051C798.062 647.905 1004.42 1199.93 1314.74 972.52C1674.56 708.831 1099.24 717.047 727.211 492.249Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38125,
    d: "M723.542 508.346C432.376 318.23 246.693 632.467 190.247 813.35C102.222 1310.35 505.003 1215.1 646.96 940.738C788.918 666.38 975.886 1225.27 1293.95 1008.83C1662.76 757.857 1087.5 745.99 723.542 508.346Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M719.312 524.303C434.958 324.142 238.422 631.707 175.697 810.51C70.3808 1304.14 476.24 1223 627.686 953.76C779.132 684.523 946.482 1249.6 1271.91 1044.39C1649.25 806.441 1074.75 774.505 719.312 524.303Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29875,
    d: "M714.528 540.104C437.333 330.141 230.183 630.659 161.257 807.164C38.7767 1296.82 447.221 1229.89 607.971 966.101C768.721 702.313 916.247 1272.88 1248.63 1079.16C1634.05 854.524 1061.02 802.558 714.528 540.104Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2575,
    d: "M709.196 555.728C439.498 336.219 221.985 629.325 146.941 803.317C7.44729 1288.4 417.978 1235.76 587.836 977.747C757.695 719.73 885.219 1295.1 1224.16 1113.09C1617.19 902.048 1046.32 830.115 709.196 555.728Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21625,
    d: "M703.323 571.157C441.449 342.369 213.84 627.706 132.77 798.972C-23.5681 1278.89 388.55 1240.62 567.309 988.684C746.068 736.752 853.435 1316.22 1198.53 1146.15C1598.67 948.954 1030.66 857.142 703.323 571.157Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.175,
    d: "M696.913 586.371C443.184 348.583 205.755 625.802 118.757 794.135C-54.2348 1268.3 358.968 1244.44 546.41 998.896C733.853 753.356 820.931 1336.22 1171.75 1178.3C1578.53 995.185 1014.07 883.605 696.913 586.371Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13375,
    d: "M689.977 601.352C444.701 354.854 197.742 623.618 104.922 788.813C-84.5124 1256.65 329.271 1247.22 525.169 1008.37C721.067 769.525 787.75 1355.07 1143.86 1209.49C1556.79 1040.68 996.572 909.474 689.977 601.352Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0925,
    d: "M682.522 616.082C445.998 361.174 189.81 621.156 91.2814 783.01C-114.365 1243.96 299.496 1248.97 503.61 1017.1C707.724 785.237 753.931 1372.76 1114.91 1239.69C1533.48 1085.4 978.177 934.717 682.522 616.082Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05125,
    d: "M674.558 630.543C447.074 367.535 181.969 618.418 77.8516 776.735C-143.756 1230.22 269.677 1249.68 481.759 1025.08C693.841 800.475 719.516 1389.25 1084.92 1268.86C1508.61 1129.27 958.913 959.302 674.558 630.543Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M666.094 644.717C447.927 373.931 174.228 615.408 64.649 769.996C-172.65 1215.47 239.852 1249.34 459.644 1032.28C679.435 815.218 684.546 1404.53 1053.93 1296.97C1482.24 1172.25 938.802 983.199 666.094 644.717Z",
    stroke: "#4AFC38",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundAsset);
export default __webpack_public_path__ + "static/media/background-asset.eb86213c4c959f0704032705a776d110.svg";
export { ForwardRef as ReactComponent };